// extracted by mini-css-extract-plugin
export default {"BtnClick":"components_BtnClick__DmqMx"};